export const styles = {
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px', // Aumentado para mais espaço entre os campos
        padding: '15px', // Adicionado padding no formulário para evitar que elementos toquem as bordas da tela
        margin: '0 auto', // Centraliza o formulário
        maxWidth: '400px', // Limita a largura máxima para melhor visualização em dispositivos maiores
        width: '100%', // Ajusta-se à largura do dispositivo
        boxSizing: 'border-box' // Garante que padding não adicione largura extra
    },
    label: {
        textalign: 'center',
        fontWeight: 'bold',
        fontSize: '26px', // Tamanho de fonte maior para melhor legibilidade
        color: '#333', // Cor mais escura para melhor contraste
    },
    input: {
        padding: '12px', // Padding maior para fácil interação
        fontSize: '16px', // Tamanho de fonte maior para entrada de dados
        borderRadius: '5px', // Borda ligeiramente mais arredondada
        border: '1px solid #ccc',
        backgroundColor: '#fff', // Fundo branco para melhorar a legibilidade
    },
    textarea: {
        padding: '12px', // Padding maior para fácil interação
        fontSize: '16px', // Tamanho de fonte maior para entrada de dados
        borderRadius: '5px', // Borda ligeiramente mais arredondada
        border: '1px solid #ccc',
        backgroundColor: '#fff', // Fundo branco para melhorar a legibilidade
        height: '5rem',
    },
    button: {
        padding: '12px 20px', // Padding maior para uma área de clique maior
        fontSize: '18px', // Tamanho de fonte maior para fácil leitura
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: '10px', // Espaço antes do botão para evitar cliques acidentais
        display: 'block', // Garante que o botão ocupe toda a largura disponível
        width: '100%',
    },
    buttonCancel: {
        padding: '12px 20px', // Padding maior para uma área de clique maior
        fontSize: '18px', // Tamanho de fonte maior para fácil leitura
        backgroundColor: '#ff5722',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: '10px', // Espaço antes do botão para evitar cliques acidentais
        display: 'block', // Garante que o botão ocupe toda a largura disponível
        width: '100%',
    }
};
